import React, { useState, useEffect } from "react";
import { handleToastClose } from "../../store/actions/layoutActions";
import {
  Grid,
  Card,
  Button,
  TextField,
  IconButton,
  withWidth,
  Snackbar,
  Tooltip,
  Modal,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardArrowDown, KeyboardArrowUp, Close } from "@material-ui/icons";
import {
  onGetIsUnlock,
  onGetDaysLimit,
  onGetPhnxLimit,
  onGetInterestRate,
  onSetInterestRate,
  onSetInitial,
  onSetDays,
  onSetPhnx,
  onSetToken,
  onConfirmStake,
  onApprove,
} from "../../store/actions/stakeActions";
import { getContractBalance } from "../../store/actions/dashboardActions";
import { PHNX_STAKING_ADDRESS } from "../../contracts/phnxStaking";
import { connect } from "react-redux";
import Arrow from "../../Assets/arrow.svg";
import DownArrow from "../../Assets/arrowDown.svg";
import spinner from "../../Assets/spinner-black.svg";

const useStyles = makeStyles((theme) => ({
  myCard: {
    background: theme.palette.card.main,
    height: "100%",
    padding: "32px",
    borderRadius: "8px",
  },

  stakeinput: {
    marginTop: "8px",
    background: theme.palette.primary.main,
    color: theme.palette.text.primary,
    borderRadius: "23px",
    border: "inherit",
    height: "80px",
    width: "100%",
    fontSize: "1.5rem",
    outline: "none",
    paddingLeft: 25,
  },
  myPara: {
    fontSize: 16,
    "@media (min-width: 2400px)": {
      fontSize: 24,
    },
    "@media (max-width : 1400px)": {
      fontSize: 12,
    },
  },

  myHeading: {
    fontSize: 24,
    "@media (min-width: 2400px)": {
      fontSize: 36,
    },
  },
  maxButton: {
    fontSize: 14,
    "@media (min-width: 2400px)": {
      fontSize: 20,
    },
  },

  arrowButton: {
    "&:hover": {
      transform: "none !important",
      boxShadow: "none !important",
    },
  },

  modalStyles: {
    height: "204px",
    margin: "auto",
    outline: "none",
    padding: "25px",
    maxWidth: "max-content",
    border: "none",
    outline: "none",
    position: "absolute",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "4px",
    boxShadow: theme.shadows[5],
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2, 4, 2),
      height: 400,
    },
  },

  btnConfirm: {
    background: "#EA8604",
    color: "white",
    height: "60px",
    borderRadius: "16px",
  },
}));

const Stake = (props) => {
  const classes = useStyles();

  const themeMode = localStorage.getItem("themeMode");

  // console.log("stake loading ----> ", props.stakeLoading);
  const [durationDaysInput, setDurationDays] = useState("");
  const [amountPhnxInput, setAmountPHNX] = useState("");
  // const [amountFocus, setAmountFocus] = useState(false);
  // const [daysFocus, setDaysFocus] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [emptyFieldErr, setEmptyFieldErr] = useState(false);
  const [displayInterest, setDisplayInterest] = useState("");
  const [emptyContractBalanceWarning, setEmptyContractBalanceWarning] =
    useState(false);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleModalOpen = () => {
    checkEmptyFieldError();
    setOpenModal(true);
  };

  var openSnackbar = false;
  const handleCloseSnackbar = () => {
    openSnackbar = false;
  };

  if (props.toastState === true && openSnackbar === true) {
    openSnackbar = false;
  } else if (props.toastState === true) {
    openSnackbar = true;
  }

  const onChangeAmount = (e) => {
    if (props.stakeLoading !== true) {
      if (
        (e.target.value.match(/^(\d+\.?\d{0,4}|\.\d{1,4})$/) &&
          e.target.value <= 20000) ||
        e.target.value == ""
      ) {
        if (e.max) {
          var test = parseFloat(props.balance).toFixed(4);
          setAmountPHNX(test);
          props.onSetPhnx(String(Math.floor(props.balance * 10000) / 10000));

          const rate =
            Number(Math.floor(props.balance * 10000) / 10000) *
            Number(durationDaysInput) *
            props.unitRate;
          props.onSetInterestRate(rate);
        } else {
          setAmountPHNX(e.target.value);
          props.onSetPhnx(e.target.value);
          const rate =
            Number(e.target.value) * Number(durationDaysInput) * props.unitRate;
          props.onSetInterestRate(rate);
        }
      }
    }
  };

  const onChangeDurationDays = (e) => {
    if (props.stakeLoading !== true) {
      // console.log("props.datsLimit", props.daysLimit, "props.");
      var reg = new RegExp("^\\d+$");
      if (
        (reg.test(e.target.value) || e.target.value == "") &&
        Number(e.target.value) <= props.daysLimit
      ) {
        setDurationDays(e.target.value);
        props.onSetDays(e.target.value);
        checkEmptyFieldError();
        const rate =
          Number(e.target.value) * Number(amountPhnxInput) * props.unitRate;
        props.onSetInterestRate(rate);
      }
    }
  };

  useEffect(() => {
    if (amountPhnxInput <= 0 && amountPhnxInput <= 0) {
      setEmptyFieldErr(false);
    } else {
      checkEmptyFieldError();
    }
  }, [amountPhnxInput, durationDaysInput]);

  const checkEmptyFieldError = () => {
    if (amountPhnxInput <= 0 || durationDaysInput <= 0) {
      setEmptyFieldErr(true);
    } else {
      if (
        String(amountPhnxInput).length > 0 &&
        String(durationDaysInput).length > 0
      ) {
        setEmptyFieldErr(false);
      } else if (
        String(amountPhnxInput).length < 1 ||
        String(durationDaysInput).length < 1
      ) {
        setEmptyFieldErr(true);
      }
    }
  };

  useEffect(() => {
    // let addresss = localStorage.getItem("localaddress");
    props.onGetPhnxLimit();
    props.onGetDaysLimit();
    if (props.address) {
      props.onGetIsUnlock(props.address);
    }
    // console.log("Updated State after Res of onGetIsUnlock", props.isUnlock);
  }, [props.address, props.balance, props]);

  useEffect(() => {
    if (props.phnxAmount && props.days) {
      props.onGetInterestRate(props.phnxAmount, props.days);
    }
  }, [props.phnxAmount, props.days]);

  useEffect(() => {
    if (props.interestRate) {
      const displayInterestLocal = props?.interestRate?.toString();
      let splittedValues = displayInterestLocal?.split(".");
      splittedValues[1] = splittedValues[1]?.slice(0, 4);

      let newValue;
      if (splittedValues[1]) {
        newValue = splittedValues[0] + "." + splittedValues[1];
      } else {
        newValue = splittedValues[0];
      }
      setDisplayInterest(newValue);
    } else {
      setDisplayInterest(0);
    }
  }, [props.interestRate]);

  useEffect(() => {
    if (
      (String(durationDaysInput).length < 1 &&
        String(amountPhnxInput).length < 1) ||
      (durationDaysInput == 0 && amountPhnxInput == 0)
    ) {
      props.onSetInterestRate(0);
      setDisplayInterest(0);
    }
  }, [durationDaysInput, amountPhnxInput]);

  const onMaxClick = () => {
    onChangeDurationDays({
      target: { value: props.daysLimit },
    });
    // setDurationDays(365);
    if (props.balance > 20000) {
      onChangeAmount({
        target: { value: "20000" },
      });
    } else {
      onChangeAmount({
        target: { value: String(props.balance).slice(0, 4) },
        max: true,
      });
    }
  };

  useEffect(() => {
    props.getContractBalance(PHNX_STAKING_ADDRESS);
    // console.log("props.contractBalance", props.contractBalance);
  }, [props.balance]);

  const handleStake = () => {
    // console.log("isUnlock", props.isUnlock);
    if (
      String(amountPhnxInput).length < 1 ||
      String(durationDaysInput).length < 1 ||
      amountPhnxInput <= 0 ||
      durationDaysInput <= 0
    ) {
      checkEmptyFieldError();
      // console.log("COMING HERE 1");
      return;
    } else if (
      props.contractBalance <= 0 ||
      displayInterest > props.contractBalance
    ) {
      // console.log("COMING HERE 2");
      setEmptyContractBalanceWarning(true);
      setTimeout(() => {
        setEmptyContractBalanceWarning(false);
      }, 4000);
      return;
    } else if (props.isUnlock) {
      handleModalOpen();
    }
  };

  return (
    <Card
      style={
        themeMode === "dark" ? { boxShadow: "0px 0px 0px 0px !important" } : {}
      }
      className={classes.myCard}
    >
      {/* {console.log(props.toastState, props.toastMessage)} */}

      <Modal open={openModal} onClose={handleModalClose}>
        <div className={classes.modalStyles}>
          {/* {console.log('Time stake', props.)} */}
          <div>
            <h3>Disclaimer</h3>
            "By clicking this you are agreeing to stake Phnx stake on the
            Phoenix DAO Foundation"
          </div>
          <div style={{ marginTop: "16px" }}>
            <Button
              onClick={() => {
                props.onConfirmStake(
                  props.address,
                  props.balance,
                  String(props.phnxAmount),
                  props.interestRate,
                  props.days * 86400,
                  props.isUnlock,
                  props.minimumStake,
                  setAmountPHNX,
                  setDurationDays
                );
                handleModalClose();
              }}
              style={{ backgroundColor: "#220ceb", color: "white" }}
            >
              Confirm
            </Button>
            <Button onClick={handleModalClose}>Cancel</Button>
          </div>
        </div>
      </Modal>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={props.toastState}
        autoHideDuration={6000}
        onClose={props.onToastClose}
        message={props.toastMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={props.onToastClose}
            >
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      {/* {console.log(props.toastMessage, props.toastState)} */}

      <Grid
        style={{ height: "100%" }}
        direction="column"
        justify="space-between"
        container
      >
        <Grid container item justify="space-between">
          <Grid item>
            <span className={classes.myHeading}>Staking</span>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              className={classes.maxButton}
              style={{ border: "1px solid #5A5A5A" }}
              onClick={() => onMaxClick()}
            >
              Max
            </Button>
          </Grid>
          <Grid style={{ margin: "12px 0px" }} xs={12} item>
            <span className={classes.myPara} style={{ color: "#828282" }}>
              Enter the amount of PHNX you would like to stake
            </span>
          </Grid>
        </Grid>

        <Grid
          style={{ marginTop: "12px" }}
          container
          item
          justify="space-between"
        >
          <Grid style={{ position: "relative" }} xs={12} sm={3} item>
            <IconButton
              className={classes.arrowButton}
              onClick={() => {
                onChangeAmount({
                  target: { value: String(Number(amountPhnxInput) + 1) },
                });
                // setAmountPHNX(Number(amountPhnxInput) + 1);
              }}
              style={{ position: "absolute", right: 0, top: 24 }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              className={classes.arrowButton}
              onClick={() => {
                if (amountPhnxInput !== 0)
                  onChangeAmount({
                    target: { value: String(Number(amountPhnxInput) - 1) },
                  });
                // setAmountPHNX(Number(amountPhnxInput) - 1);
              }}
              style={{ position: "absolute", right: 0, top: 64 }}
            >
              <KeyboardArrowDown />
            </IconButton>
            <span
              className={classes.myPara}
              style={{ color: "#828282", marginLeft: "5px" }}
            >
              Quantity
            </span>
            <br />
            <Tooltip title="Type in the amount of $PHNX you will like to stake or use the navigation tool by the right to increase or decrease the amount.">
              <input
                type="text"
                className={classes.stakeinput}
                disabled={props.stakeLoading ? true : false}
                value={amountPhnxInput}
                onChange={onChangeAmount}
                placeholder="0.0"
              />
            </Tooltip>
          </Grid>
          <Grid xs={12} sm={1} style={{ display: "flex" }} item>
            <img
              height="32"
              width="100%"
              style={
                props.width === "xs"
                  ? { margin: "12px 0px" }
                  : { margin: "auto", marginBottom: "25px" }
              }
              src={props.width === "xs" ? DownArrow : Arrow}
              alt="right arrow"
            />
          </Grid>
          <Grid style={{ position: "relative" }} xs={12} sm={3} item>
            <IconButton
              className={classes.arrowButton}
              onClick={() => {
                onChangeDurationDays({
                  target: { value: Number(durationDaysInput) + 1 },
                });
                // setDurationDays(Number(durationDaysInput) + 1);
              }}
              style={{ position: "absolute", right: 0, top: 24 }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              className={classes.arrowButton}
              onClick={() => {
                if (durationDaysInput !== 0)
                  onChangeDurationDays({
                    target: { value: Number(durationDaysInput) - 1 },
                  });
                // setDurationDays(Number(durationDaysInput) - 1);
              }}
              style={{ position: "absolute", right: 0, top: 64 }}
            >
              <KeyboardArrowDown />
            </IconButton>
            <span
              className={classes.myPara}
              style={{ color: "#828282", marginLeft: "5px" }}
            >
              Duration (days)
            </span>
            <br />
            <Tooltip title="Type in the number of days you will like to stake your $PHNX or use the navigation tool to increase or decrease the days.">
              <input
                type="text"
                className={classes.stakeinput}
                disabled={props.stakeLoading ? true : false}
                onChange={onChangeDurationDays}
                value={durationDaysInput}
                placeholder="0.0"
              />
            </Tooltip>
          </Grid>
          <Grid xs={12} sm={1} style={{ display: "flex" }} item>
            <img
              height="32"
              width="100%"
              style={
                props.width === "xs"
                  ? { margin: "12px 0px" }
                  : { margin: "auto", marginBottom: "25px" }
              }
              src={props.width === "xs" ? DownArrow : Arrow}
              alt="right arrow"
            />
          </Grid>
          <Grid xs={12} sm={3} item>
            <span
              className={classes.myPara}
              style={{ color: "#828282", marginLeft: "5px" }}
            >
              Spot Interest
            </span>{" "}
            <br />
            <Tooltip title="The spot reward is automatically calculated for you based on the amount of $PHNX staked and the number of days scheduled for the staking.">
              <input
                type="text"
                className={classes.stakeinput}
                value={displayInterest}
                disabled="true"
                placeholder="0.0"
              />
            </Tooltip>
          </Grid>
        </Grid>

        <Grid style={props.width === "xs" ? { marginTop: "12px" } : {}}>
          {emptyFieldErr && (
            <p style={{ color: "#ff0000", marginTop: -20 }}>
              Fields shouldn't be zero or empty!
            </p>
          )}
          {emptyContractBalanceWarning && (
            <p style={{ color: "#eed202", marginTop: -20 }}>
              For now we can't perform this transaction try again very soon!
            </p>
          )}
          {props.isUnlock ? (
            <Button
              variant="contained"
              size="large"
              className={classes.btnConfirm}
              onClick={handleStake}
              disabled={props.stakeLoading || props.network != 1}
            >
              {props.stakeLoading && <img src={spinner} />}
              <span
                className={classes.myPara}
                style={{ textTransform: "none" }}
              >
                Confirm Stake
              </span>
            </Button>
          ) : (
            <Button
              variant="contained"
              size="large"
              className={classes.btnConfirm}
              onClick={() => props.approve(props.isUnlock, props.address)}
              disabled={props.stakeLoading || props.network != 1}
            >
              {props.stakeLoading && <img src={spinner} />}
              <span
                className={classes.myPara}
                style={{ textTransform: "none" }}
              >
                Approve PHNX
              </span>
            </Button>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    toastMessage: state.layoutReducer.toastMessage,
    toastState: state.layoutReducer.toastState,
    days: state.stakeReducer.days,
    token: state.stakeReducer.token,
    initial: state.stakeReducer.initial,
    address: state.layoutReducer.address,
    unitRate: state.stakeReducer.initialRate,
    phnxLimit: state.stakeReducer.phnxLimit,
    phnxAmount: state.stakeReducer.phnxAmount,
    daysLimit: state.stakeReducer.daysLimit,
    balance: state.dashboardReducer.balance,
    tokensList: state.stakeReducer.tokenList,
    stakeLoading: state.layoutReducer.stakeLoading,
    interestRate: state.stakeReducer.interestRate,
    stakedPhnx: state.dashboardReducer.stakedPhnx,
    interest: state.dashboardReducer.interest,
    isUnlock: state.stakeReducer.isUnlock,
    stakeLoading: state.layoutReducer.stakeLoading,
    minimumStake: state.stakeReducer.minimumStake,
    contractBalance: state.dashboardReducer.contractBalance,
    network: state.layoutReducer.network,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToastClose: () => dispatch(handleToastClose()),
    onSetInitial: () => dispatch(onSetInitial()),
    onGetPhnxLimit: () => dispatch(onGetPhnxLimit()),
    onSetPhnx: (phnx) => dispatch(onSetPhnx(phnx)),
    onSetDays: (days) => dispatch(onSetDays(days)),
    onGetDaysLimit: () => dispatch(onGetDaysLimit()),
    onSetToken: (token) => dispatch(onSetToken(token)),
    // getBalance: (address) => dispatch(getBalance(address)),
    onGetIsUnlock: (address) => dispatch(onGetIsUnlock(address)),
    onSetInterestRate: (interest) => dispatch(onSetInterestRate(interest)),
    onGetInterestRate: (initial, phnx, days, token, setInitial) =>
      dispatch(onGetInterestRate(initial, phnx, days, token, setInitial)),
    getContractBalance: (address) => dispatch(getContractBalance(address)),
    // onGetMinInterestRate: () => dispatch(onGetMinInterestRate()),
    onConfirmStake: (
      address,
      balance,
      stakeAmount,
      interestRate,
      stakeDuration,
      isUnlock,
      minimumStake,
      setAmountPHNX,
      setDurationDays
    ) =>
      dispatch(
        onConfirmStake(
          address,
          balance,
          stakeAmount,
          interestRate,
          stakeDuration,
          isUnlock,
          minimumStake,
          setAmountPHNX,
          setDurationDays
        )
      ),
    approve: (isUnlock, address) => dispatch(onApprove(isUnlock, address)),
  };
};

export default withWidth()(connect(mapStateToProps, mapDispatchToProps)(Stake));
